import {
  IConfigurationParams,
  ConfigurationNames,
} from '../../../../graphql/configuration/models/configuration.models';

export const getAllowedGroupCodes = (configuration: IConfigurationParams[]): string[] => {
  const externalAppointments = configuration.find(
    (params) => params.name === ConfigurationNames.externalAppointments,
  );

  try {
    const parsed = externalAppointments ? JSON.parse(externalAppointments.configuration) : null;
    return parsed && Array.isArray(parsed['allowed-le-group-codes'])
      ? parsed['allowed-le-group-codes']
      : [];
  } catch (e) {
    console.error('Failed to parse external-appointments configuration:', e);
    return [];
  }
};